import { render, staticRenderFns } from "./NewsIcon.vue?vue&type=template&id=2b8f3244&"
import script from "./NewsIcon.vue?vue&type=script&lang=js&"
export * from "./NewsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports